import "../../styles/about.css";

import React from "react";

interface LoadingProps extends React.HTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
}

const Loading: React.FC<LoadingProps> = () => {
  return (
    <>
      <div className="dot-flashing"></div>
      <style jsx>{`
        .dot-flashing {
          position: relative;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #191919;
          color: #191919;
          animation: dot-flashing 1s infinite linear alternate;
          animation-delay: 0.5s;
        }
        .dot-flashing::before,
        .dot-flashing::after {
          content: "";
          display: inline-block;
          position: absolute;
          top: 0;
        }
        .dot-flashing::before {
          left: -15px;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #191919;
          color: #191919;
          animation: dot-flashing 1s infinite alternate;
          animation-delay: 0s;
        }
        .dot-flashing::after {
          left: 15px;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #191919;
          color: #191919;
          animation: dot-flashing 1s infinite alternate;
          animation-delay: 1s;
        }
        @keyframes dot-flashing {
          0% {
            background-color: #191919;
          }
          50%,
          100% {
            background-color: rgba(152, 128, 255, 0.2);
          }
        }
      `}</style>
    </>
  );
};

export default Loading;
